/** The avatar colours an opponent may get. */
const OPPONENT_COLORS = ['--wh-plum', '--wh-teal', '--wh-coral', '--wh-sun'] as const;

/** An opponent's avatar colour: always the same for the same name. */
export const opponentColor = (name: string): string => {
  let hash = 0;
  for (const char of name) {
    hash = (hash * 31 + (char.codePointAt(0) ?? 0)) >>> 0;
  }
  return OPPONENT_COLORS[hash % OPPONENT_COLORS.length];
};
